export interface ExtractedPlainText {
  text: string;
}

function walkNode(node: Node, buffer: string[]) {
  if (node.nodeType === Node.TEXT_NODE) {
    buffer.push(node.textContent ?? '');
    return;
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return;
  }

  const element = node as HTMLElement;

  if (element.tagName.toLowerCase() === 'br') {
    buffer.push('\n');
    return;
  }

  Array.from(element.childNodes).forEach((childNode) => {
    walkNode(childNode, buffer);
  });
}

export function extractPlainText(html: string): ExtractedPlainText {
  if (typeof DOMParser === 'undefined') {
    return {
      text: html.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, ''),
    };
  }

  const documentFragment = new DOMParser().parseFromString(html, 'text/html');
  const buffer: string[] = [];

  Array.from(documentFragment.body.childNodes).forEach((childNode) => {
    walkNode(childNode, buffer);
  });

  return {
    text: buffer.join('').replace(/\u00a0/g, ' '),
  };
}
